import React, { useState, useEffect, useCallback } from "react"

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  CardTitle,
  Input,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  FormFeedback,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import classnames from "classnames"
import { Link } from "react-router-dom"
import { useParams } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import {
  qaOfferEdit,
  qaUpdateOffer,
  supplierNameListing,
  offerStatusListing,
  incotermCityListing,
  materialStandardListing,
  packingStandardListing,
  environmentalAndHealthCertificationListing,
  packagingListing,
  deliveredOnListing,
  heaveyColliListing,
  qaUserListAccordingRoleListing,
} from "../../../store/actions"

const QaEditOffer = props => {
  document.title = "Edit Offer"
  const { id } = useParams()
  const dispatch = useDispatch()

  const [activeTab, setactiveTab] = useState(1)
  const [activeTabVartical, setoggleTabVertical] = useState(1)

  const [passedSteps, setPassedSteps] = useState([1])
  const [passedStepsVertical, setPassedStepsVertical] = useState([1])
  const [productNumberNameCategory, setProductNumberNameCategory] =
    useState(null)

  function toggleTab(tab) {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab]
      if (tab >= 1 && tab <= 4) {
        setactiveTab(tab)
        setPassedSteps(modifiedSteps)
      }
    }
  }

  function toggleTabVertical(tab) {
    if (activeTabVartical !== tab) {
      var modifiedSteps = [...passedStepsVertical, tab]

      if (tab >= 1 && tab <= 4) {
        setoggleTabVertical(tab)
        setPassedStepsVertical(modifiedSteps)
      }
    }
  }

  const [details, setDetails] = useState({})
  const [supplierName, setSupplierName] = useState([])
  const [offerStatus, setOfferStatus] = useState([])
  const [incotermCity, setIncotermCity] = useState([])
  const [materialStandard, setMaterialStandard] = useState([])
  const [packingStandard, setPackingStandard] = useState([])
  const [
    environmentalAndHealthCertification,
    setEnvironmentalAndHealthCertification,
  ] = useState([])
  const [packaging, setPackaging] = useState([])
  const [deliveredOn, setDeliveredOn] = useState([])
  const [heaveyColli, setHeaveyColli] = useState([])
  const [exportJyskList, setExportJyskList] = useState(0)
  const [userListAccordingRole, setUserListAccordingRole] = useState([])

  useEffect(() => {
    dispatch(supplierNameListing())
    dispatch(offerStatusListing())
    dispatch(incotermCityListing())
    dispatch(materialStandardListing())
    dispatch(packingStandardListing())
    dispatch(environmentalAndHealthCertificationListing())
    dispatch(packagingListing())
    dispatch(deliveredOnListing())
    dispatch(heaveyColliListing())
    dispatch(qaUserListAccordingRoleListing({ user_role: "qa" }, props.history))
    dispatch(qaOfferEdit(id))
  }, [])

  const offersData = useSelector(state => state.qaOffer)
  const supplierNameData = useSelector(state => state.supplierName.supplierName) ///1st supplierName is from reducer
  const offerStatusData = useSelector(state => state.offerStatus.offerStatus)
  const incotermCityData = useSelector(state => state.incotermCity.incotermCity)
  const materialStandardData = useSelector(
    state => state.materialStandard.materialStandard
  )
  const packingStandardData = useSelector(
    state => state.packingStandard.packingStandard
  )
  const environmentalAndHealthCertificationData = useSelector(
    state =>
      state.environmentalAndHealthCertification
        .environmentalAndHealthCertification
  )
  const packagingData = useSelector(state => state.packaging.packaging)
  const deliveredOnData = useSelector(state => state.deliveredOn.deliveredOn)
  const heaveyColliData = useSelector(state => state.heaveyColli.heaveyColli)

  const userListAccordingRoleData = useSelector(
    state => state.qaUserListAccordingRole.userListAccordingRole
  )

  useEffect(() => {
    let offers = []
    if (offersData.offer) {
      offers = offersData.offer.filter(offer => offer.offer_id == id)
    }
    setSupplierName(supplierNameData)
    setOfferStatus(offerStatusData)
    setIncotermCity(incotermCityData)
    setMaterialStandard(materialStandardData)
    setPackingStandard(packingStandardData)
    setEnvironmentalAndHealthCertification(
      environmentalAndHealthCertificationData
    )
    setPackaging(packagingData)
    setDeliveredOn(deliveredOnData)
    setHeaveyColli(heaveyColliData)
    setUserListAccordingRole(userListAccordingRoleData)
    if (offers.length > 0) {
      setDetails(offers[0])
      let productName = offers[0]["product_name"]
        ? offers[0]["product_name"]
        : ""
      let productNumber = offers[0]["product_number"]
        ? offers[0]["product_number"]
        : ""
      let product_category_name = offers[0]["product_category_name"]
        ? offers[0]["product_category_name"]
        : ""

      let data =
        "Product number :- " +
        productNumber +
        ", Product category :- " +
        product_category_name

      if (productName) {
        data += ", Product name :- " + productName
      }
      setProductNumberNameCategory(data)
    } else {
      props.history.push("/offers/list")
    }
  }, [
    supplierNameData,
    offerStatusData,
    incotermCityData,
    materialStandardData,
    packingStandardData,
    environmentalAndHealthCertificationData,
    packagingData,
    deliveredOnData,
    heaveyColliData,
    userListAccordingRoleData,
  ])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      offer_id: id,
      offer_status_id:
        details && details.offer_status_id ? details.offer_status_id : "",
      vendor_article_no:
        details && details.vendor_article_no ? details.vendor_article_no : "",
      supplier_id: details && details.supplier_id ? details.supplier_id : "",
      production_time:
        details && details.production_time ? details.production_time : "",
      incoterm_city_id:
        details && details.incoterm_city_id ? details.incoterm_city_id : "",
      material_standard_id:
        details && details.material_standard_id
          ? details.material_standard_id
          : "",
      packing_standard_id:
        details && details.packing_standard_id
          ? details.packing_standard_id
          : "",
      env_health_id:
        details && details.env_health_id ? details.env_health_id : "",
      non_compliance:
        details && details.non_compliance ? details.non_compliance : "",
      sbn_comments: details && details.sbn_comments ? details.sbn_comments : "",
      quality_control:
        details && details.quality_control ? details.quality_control : "",
      color_code_gloss:
        details && details.color_code_gloss ? details.color_code_gloss : "",
      purchase_price_fsc:
        details && details.purchase_price_fsc ? details.purchase_price_fsc : 0,
      yearly_purchase_fsc:
        details && details.yearly_purchase_fsc
          ? details.yearly_purchase_fsc
          : 0,
      purchase_price_non_fsc:
        details && details.purchase_price_non_fsc
          ? details.purchase_price_non_fsc
          : 0,
      yearly_purchase_non_fsc:
        details && details.yearly_purchase_non_fsc
          ? details.yearly_purchase_non_fsc
          : 0,
      purchasing_price_comments:
        details && details.purchasing_price_comments
          ? details.purchasing_price_comments
          : "",
      sales_price_fsc:
        details && details.sales_price_fsc ? details.sales_price_fsc : 0,
      sales_margin_fsc:
        details && details.sales_margin_fsc ? details.sales_margin_fsc : 0,
      yearly_sales_fsc:
        details && details.yearly_sales_fsc ? details.yearly_sales_fsc : 0,
      sales_price_non_fsc:
        details && details.sales_price_non_fsc
          ? details.sales_price_non_fsc
          : 0,
      sales_margin_non_fsc:
        details && details.sales_margin_non_fsc
          ? details.sales_margin_non_fsc
          : 0,
      yearly_sales_non_fsc:
        details && details.yearly_sales_non_fsc
          ? details.yearly_sales_non_fsc
          : 0,
      export_jysk_list:
        details && details.exportJyskList ? details.exportJyskList : 0,
      full_truck: details && details.full_truck ? details.full_truck : "",
      container: details && details.container ? details.container : "",
      moq: details && details.moq ? details.moq : "",
      net_weight: details && details.net_weight ? details.net_weight : "",
      gross_weight: details && details.gross_weight ? details.gross_weight : "",
      packaging_id: details && details.packaging_id ? details.packaging_id : "",
      delivered_on: details && details.delivered_on ? details.delivered_on : "",
      heavy_colli_id:
        details && details.heavy_colli_id ? details.heavy_colli_id : "",
      units_per_box:
        details && details.units_per_box ? details.units_per_box : "",
      bom_per_article:
        details && details.bom_per_article ? details.bom_per_article : "",
      master_cardboard_box:
        details && details.master_cardboard_box
          ? details.master_cardboard_box
          : "",
      packing_comments:
        details && details.packing_comments ? details.packing_comments : "",
      qa_user_id: details && details.user_type_id ? details.user_type_id : "",
      sample_request:
        details && details.sample_request ? details.sample_request : "",
      sample_comments:
        details && details.sample_comments ? details.sample_comments : "",
      sample_status:
        details && details.sample_status ? details.sample_status : "",
      qa_sample_checking_comments:
        details && details.qa_sample_checking_comments
          ? details.qa_sample_checking_comments
          : "",
      sales_sample_checking_comments:
        details && details.sales_sample_checking_comments
          ? details.sales_sample_checking_comments
          : "",
      sample_freight_cost:
        details && details.sample_freight_cost
          ? details.sample_freight_cost
          : "",
      sample_main_material:
        details && details.sample_main_material
          ? details.sample_main_material
          : "",
      sample_hardware:
        details && details.sample_hardware ? details.sample_hardware : "",
      sample_surface_treatment:
        details && details.sample_surface_treatment
          ? details.sample_surface_treatment
          : "",
    },
    validationSchema: Yup.object({
      offer_status_id: Yup.string().required("Offer status is required"),
      supplier_id: Yup.string().required("Supplier is required"),
      incoterm_city_id: Yup.string().required("Incoterm is required"),

      production_time: Yup.string()
        .required("Production time is required. this is must be a number.")
        .matches(
          /^[0-9]+$/,
          "Positive numbers are allowed without dots, negetive or decimal"
        ),

      material_standard_id: Yup.string().required(
        "Material standard is required"
      ),
      packing_standard_id: Yup.string().required(
        "Packing standard is required"
      ),
      env_health_id: Yup.string().required("Env health is required"),
      purchase_price_fsc: Yup.number().required("Purchase FSC is required"),
      purchase_price_non_fsc: Yup.number().required(
        "Purchase (NON FSC) is required"
      ),
      yearly_purchase_fsc: Yup.number().required(
        "Yearly purchase FSC is required"
      ),
      yearly_purchase_non_fsc: Yup.number().required(
        "Yearly purchase (NON FSC) is required"
      ),
      yearly_purchase_non_fsc: Yup.number().required(
        "Yearly purchase (NON FSC) is required"
      ),
      sales_price_fsc: Yup.number().required("Sales price FSC is required"),
      sales_margin_fsc: Yup.number().required("Sales margin FSC is required"),
      yearly_sales_fsc: Yup.number().required("Yearly sales FSC is required"),
      yearly_sales_non_fsc: Yup.number().required(
        "Yearly sales (NON FSC) is required"
      ),
      sales_price_non_fsc: Yup.number().required(
        "Sales price (NON FSC) is required"
      ),
      sales_margin_non_fsc: Yup.number().required(
        "Sales margin (NON FSC) is required"
      ),
      full_truck: Yup.number().required("Full truck is required"),
      container: Yup.number().required("20ST Container is required"),
      moq: Yup.number().required("Moq is required"),
      net_weight: Yup.number().required("Net weight is required"),
      gross_weight: Yup.number().required("Gross weight is required"),
      packaging_id: Yup.string().required("Packaging is required"),
      delivered_on: Yup.string().required("Delivered on is required"),
      heavy_colli_id: Yup.string().required("Heavy colli is required"),
      units_per_box: Yup.number().required("Units per box is required"),
      bom_per_article: Yup.number().required("BOM per article is required"),
      master_cardboard_box: Yup.number().required(
        "Master card box is required"
      ),
    }),

    onSubmit: values => {
      dispatch(qaUpdateOffer(values, props.history))
    },
  })

  const offer = useSelector(state => state.qaOffer)
  const { error } = useSelector(state => ({
    error: state.qaOffer.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            breadcrumbItem="Edit Offer"
            // extra={productNumberNameCategory}
          />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">
                    <Row>
                      <Col md={4}>
                        <b className="align-left">
                          Product Number :-{" "}
                          {details && details.product_number
                            ? details.product_number
                            : ""}
                        </b>
                      </Col>
                      <Col md={4}>
                        <b className="align-middle">
                          Product Name :-{" "}
                          {details && details.product_name
                            ? details.product_name
                            : ""}
                        </b>
                      </Col>
                      <Col md={4}>
                        <b className="align-right">
                          Product Category :-{" "}
                          {details && details.product_category_name
                            ? details.product_category_name
                            : ""}
                        </b>
                      </Col>
                    </Row>
                  </CardTitle>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="editOfferForm"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <div className="wizard clearfix">
                      <div className="steps clearfix">
                        <ul>
                          <NavItem
                            className={classnames({ current: activeTab === 1 })}
                          >
                            <NavLink
                              className={classnames({
                                current: activeTab === 1,
                              })}
                              onClick={() => {
                                setactiveTab(1)
                              }}
                              disabled={!(passedSteps || []).includes(1)}
                            >
                              <span className="number">01</span> Offer Details
                            </NavLink>
                          </NavItem>
                          <NavItem
                            className={classnames({ current: activeTab === 2 })}
                          >
                            <NavLink
                              className={classnames({
                                active: activeTab === 2,
                              })}
                              onClick={() => {
                                setactiveTab(2)
                              }}
                              disabled={!(passedSteps || []).includes(2)}
                            >
                              <span className="number">02</span> Offer Packing
                            </NavLink>
                          </NavItem>
                          <NavItem
                            className={classnames({ current: activeTab === 3 })}
                          >
                            <NavLink
                              className={classnames({
                                active: activeTab === 3,
                              })}
                              onClick={() => {
                                setactiveTab(3)
                              }}
                              disabled={!(passedSteps || []).includes(3)}
                            >
                              <span className="number">03</span> Sample Details
                            </NavLink>
                          </NavItem>
                        </ul>
                      </div>
                      <div className="content clearfix mt-4 addformsection">
                        <TabContent activeTab={activeTab}>
                          <TabPane tabId={1}>
                            {/* <Form> */}
                            <Row>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label htmlFor="add-offer-offer-status">
                                    Offer Status{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <select
                                    readOnly={true}
                                    name="offer_status_id"
                                    id="add-offer-offer-status"
                                    className={
                                      validation.touched.offer_status_id &&
                                      validation.errors.offer_status_id
                                        ? "form-control is-invalid"
                                        : "form-control"
                                    }
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={
                                      validation.values.offer_status_id || ""
                                    }
                                  >
                                    <option value="">Choose...</option>
                                    {offerStatus &&
                                      offerStatus.map((offerStatus, ofs) => (
                                        <option
                                          key={"ofs" + ofs}
                                          value={offerStatus.id}
                                        >
                                          {offerStatus.offer_status}
                                        </option>
                                      ))}
                                  </select>
                                  {validation.touched.offer_status_id &&
                                  validation.errors.offer_status_id ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.offer_status_id}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label htmlFor="add-offer-Vendor-article-number">
                                    Vendor Article Number
                                  </Label>
                                  <Input
                                    readOnly={true}
                                    name="vendor_article_no"
                                    type="text"
                                    className="form-control"
                                    id="add-offer-Vendor-article-number"
                                    placeholder="Enter your vender article number"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={
                                      validation.values.vendor_article_no || ""
                                    }
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label htmlFor="add-offer-supplier-id">
                                    Supplier Name{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <select
                                    readOnly={true}
                                    name="supplier_id"
                                    id="add-offer-supplier-id"
                                    className={
                                      validation.touched.supplier_id &&
                                      validation.errors.supplier_id
                                        ? "form-control is-invalid"
                                        : "form-control"
                                    }
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.supplier_id || ""}
                                  >
                                    <option value="">Choose...</option>
                                    {supplierName &&
                                      supplierName.map((supplierName, snk) => (
                                        <option
                                          key={"snk" + snk}
                                          value={supplierName.id}
                                        >
                                          {supplierName.name}
                                        </option>
                                      ))}
                                  </select>
                                  {validation.touched.supplier_id &&
                                  validation.errors.supplier_id ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.supplier_id}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label htmlFor="basicpill-production-input1">
                                    Production Time{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    readOnly={true}
                                    name="production_time"
                                    type="number"
                                    className={
                                      validation.touched.production_time &&
                                      validation.errors.production_time
                                        ? "form-control is-invalid"
                                        : "form-control"
                                    }
                                    id="basicpill-production-input1"
                                    placeholder="Enter production time in number of days"
                                    onChange={e => {
                                      validation.handleChange(e)
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={
                                      validation.values.production_time || ""
                                    }
                                  />
                                  {validation.touched.production_time &&
                                  validation.errors.production_time ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.production_time}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label htmlFor="add-offer-incoterm-city">
                                    Incoterm City (port){" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <select
                                    readOnly={true}
                                    className={
                                      validation.touched.incoterm_city_id &&
                                      validation.errors.incoterm_city_id
                                        ? "form-control is-invalid"
                                        : "form-control"
                                    }
                                    name="incoterm_city_id"
                                    id="add-offer-incoterm-city"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={
                                      validation.values.incoterm_city_id || ""
                                    }
                                  >
                                    <option value="">Choose...</option>
                                    {incotermCity &&
                                      incotermCity.map((incotermCity, icc) => (
                                        <option
                                          key={"icc" + icc}
                                          value={incotermCity.id}
                                        >
                                          {incotermCity.city}
                                        </option>
                                      ))}
                                  </select>
                                  {validation.touched.incoterm_city_id &&
                                  validation.errors.incoterm_city_id ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.incoterm_city_id}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label htmlFor="add-offer-material-standard">
                                    Material Standard{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <select
                                    readOnly={true}
                                    className={
                                      validation.touched.material_standard_id &&
                                      validation.errors.material_standard_id
                                        ? "form-control is-invalid"
                                        : "form-control"
                                    }
                                    name="material_standard_id"
                                    id="add-offer-material-standard"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={
                                      validation.values.material_standard_id ||
                                      ""
                                    }
                                  >
                                    <option value="">Choose...</option>
                                    {materialStandard &&
                                      materialStandard.map(
                                        (materialStandard, ms) => (
                                          <option
                                            key={"ms" + ms}
                                            value={materialStandard.id}
                                          >
                                            {materialStandard.material_standard}
                                          </option>
                                        )
                                      )}
                                  </select>
                                  {validation.touched.material_standard_id &&
                                  validation.errors.material_standard_id ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.material_standard_id}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label htmlFor="add-offer-packing-standard">
                                    Packing Standard{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <select
                                    readOnly={true}
                                    className={
                                      validation.touched.packing_standard_id &&
                                      validation.errors.packing_standard_id
                                        ? "form-control is-invalid"
                                        : "form-control"
                                    }
                                    name="packing_standard_id"
                                    id="add-offer-packing-standard"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={
                                      validation.values.packing_standard_id ||
                                      ""
                                    }
                                  >
                                    <option value="">Choose...</option>
                                    {packingStandard &&
                                      packingStandard.map(
                                        (packingStandard, ps) => (
                                          <option
                                            key={"ps" + ps}
                                            value={packingStandard.id}
                                          >
                                            {packingStandard.packing_standard}
                                          </option>
                                        )
                                      )}
                                  </select>
                                  {validation.touched.packing_standard_id &&
                                  validation.errors.packing_standard_id ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.packing_standard_id}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label htmlFor="add-offer-env&hlth-certification">
                                    Environmental and Health Certification{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <select
                                    readOnly={true}
                                    className={
                                      validation.touched.env_health_id &&
                                      validation.errors.env_health_id
                                        ? "form-control is-invalid"
                                        : "form-control"
                                    }
                                    name="env_health_id"
                                    id="add-offer-env&hlth-certification"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={
                                      validation.values.env_health_id || ""
                                    }
                                  >
                                    <option value="">Choose...</option>
                                    {environmentalAndHealthCertification &&
                                      environmentalAndHealthCertification.map(
                                        (
                                          environmentalAndHealthCertification,
                                          enhc
                                        ) => (
                                          <option
                                            key={"enhc" + enhc}
                                            value={
                                              environmentalAndHealthCertification.id
                                            }
                                          >
                                            {
                                              environmentalAndHealthCertification.certs
                                            }
                                          </option>
                                        )
                                      )}
                                  </select>
                                  {validation.touched.env_health_id &&
                                  validation.errors.env_health_id ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.env_health_id}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="12">
                                <div className="mb-3">
                                  <Label htmlFor="basicpill-compliance-input1">
                                    NON-compliance
                                  </Label>
                                  <textarea
                                    name="non_compliance"
                                    id="basicpill-compliance-input1"
                                    className="form-control"
                                    rows="3"
                                    placeholder="Free Text"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={
                                      validation.values.non_compliance || ""
                                    }
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="12">
                                <div className="mb-3">
                                  <Label htmlFor="basicpill-comments-input1">
                                    SBN comments
                                  </Label>
                                  <textarea
                                    name="sbn_comments"
                                    id="basicpill-comments-input1"
                                    className="form-control"
                                    rows="3"
                                    placeholder="Free Text"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.sbn_comments || ""}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="12">
                                <div className="mb-3">
                                  <Label htmlFor="basicpill-quality-input1">
                                    Quality Control
                                  </Label>
                                  <textarea
                                    name="quality_control"
                                    id="basicpill-quality-input1"
                                    className="form-control"
                                    rows="3"
                                    placeholder="Free Text"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={
                                      validation.values.quality_control || ""
                                    }
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="12">
                                <div className="mb-3">
                                  <Label htmlFor="basicpill-color-input1">
                                    Color code and Gloss
                                  </Label>
                                  <textarea
                                    name="color_code_gloss"
                                    id="basicpill-color-input1"
                                    className="form-control"
                                    rows="3"
                                    placeholder="Free Text"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={
                                      validation.values.color_code_gloss || ""
                                    }
                                  />
                                </div>
                              </Col>
                            </Row>
                            {/* </Form> */}
                          </TabPane>
                          <TabPane tabId={2}>
                            <div>
                              <Row>
                                <Col lg="4">
                                  <div className="mb-3">
                                    <Label htmlFor="basicpill-truck-input11">
                                      Full Truck/40HC
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      readOnly={true}
                                      name="full_truck"
                                      type="text"
                                      className={
                                        validation.touched.full_truck &&
                                        validation.errors.full_truck
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      id="basicpill-truck-input11"
                                      placeholder="Number"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.full_truck || ""}
                                    />
                                    {validation.touched.full_truck &&
                                    validation.errors.full_truck ? (
                                      <FormFeedback type="invalid">
                                        {validation.errors.full_truck}
                                      </FormFeedback>
                                    ) : null}
                                  </div>
                                </Col>
                                <Col lg="4">
                                  <div className="mb-3">
                                    <Label htmlFor="basicpill-20st-input11">
                                      20ST Container
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      readOnly={true}
                                      name="container"
                                      type="text"
                                      className={
                                        validation.touched.container &&
                                        validation.errors.container
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      id="basicpill-20st-input11"
                                      placeholder="Number"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.container || ""}
                                    />
                                    {validation.touched.container &&
                                    validation.errors.container ? (
                                      <FormFeedback type="invalid">
                                        {validation.errors.container}
                                      </FormFeedback>
                                    ) : null}
                                  </div>
                                </Col>
                                <Col lg="4">
                                  <div className="mb-3">
                                    <Label htmlFor="basicpill-moq-input11">
                                      MOQ
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      readOnly={true}
                                      name="moq"
                                      type="text"
                                      className={
                                        validation.touched.moq &&
                                        validation.errors.moq
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      id="basicpill-moq-input11"
                                      placeholder="Number"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.moq || ""}
                                    />
                                    {validation.touched.moq &&
                                    validation.errors.moq ? (
                                      <FormFeedback type="invalid">
                                        {validation.errors.moq}
                                      </FormFeedback>
                                    ) : null}
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="4">
                                  <div className="mb-3">
                                    <Label htmlFor="basicpill-net-input11">
                                      Net Weight
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      readOnly={true}
                                      name="net_weight"
                                      type="text"
                                      className={
                                        validation.touched.net_weight &&
                                        validation.errors.net_weight
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      id="basicpill-net-input11"
                                      placeholder="Number"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.net_weight || ""}
                                    />
                                    {validation.touched.net_weight &&
                                    validation.errors.net_weight ? (
                                      <FormFeedback type="invalid">
                                        {validation.errors.net_weight}
                                      </FormFeedback>
                                    ) : null}
                                  </div>
                                </Col>
                                <Col lg="4">
                                  <div className="mb-3">
                                    <Label htmlFor="basicpill-gross-input12">
                                      Gross Weight
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      readOnly={true}
                                      name="gross_weight"
                                      type="text"
                                      className={
                                        validation.touched.gross_weight &&
                                        validation.errors.gross_weight
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      id="basicpill-gross-input12"
                                      placeholder="Number"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={
                                        validation.values.gross_weight || ""
                                      }
                                    />
                                    {validation.touched.gross_weight &&
                                    validation.errors.gross_weight ? (
                                      <FormFeedback type="invalid">
                                        {validation.errors.gross_weight}
                                      </FormFeedback>
                                    ) : null}
                                  </div>
                                </Col>
                                <Col lg="4">
                                  <div className="mb-3">
                                    <Label htmlFor="add-offer-packaging">
                                      Packaging{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <select
                                      readOnly={true}
                                      className={
                                        validation.touched.packaging_id &&
                                        validation.errors.packaging_id
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      name="packaging_id"
                                      id="add-offer-packaging"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={
                                        validation.values.packaging_id || ""
                                      }
                                    >
                                      <option value="">Choose...</option>
                                      {packaging &&
                                        packaging.map((packaging, pck) => (
                                          <option
                                            key={"pck" + pck}
                                            value={packaging.id}
                                          >
                                            {packaging.packaging}
                                          </option>
                                        ))}
                                    </select>
                                    {validation.touched.packaging_id &&
                                    validation.errors.packaging_id ? (
                                      <FormFeedback type="invalid">
                                        {validation.errors.packaging_id}
                                      </FormFeedback>
                                    ) : null}
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label htmlFor="add-offer-delivered-on">
                                      Delivered On{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <select
                                      readOnly={true}
                                      className={
                                        validation.touched.delivered_on &&
                                        validation.errors.delivered_on
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      name="delivered_on"
                                      id="add-offer-delivered-on"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={
                                        validation.values.delivered_on || ""
                                      }
                                    >
                                      <option value="">Choose...</option>
                                      {deliveredOn &&
                                        deliveredOn.map((deliveredOn, dn) => (
                                          <option
                                            key={"dn" + dn}
                                            value={deliveredOn.id}
                                          >
                                            {deliveredOn.delivery_name}
                                          </option>
                                        ))}
                                    </select>
                                    {validation.touched.delivered_on &&
                                    validation.errors.delivered_on ? (
                                      <FormFeedback type="invalid">
                                        {validation.errors.delivered_on}
                                      </FormFeedback>
                                    ) : null}
                                  </div>
                                </Col>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label htmlFor="add-offer-heavey-colli">
                                      Heavey Colli{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <select
                                      readOnly={true}
                                      className={
                                        validation.touched.heavy_colli_id &&
                                        validation.errors.heavy_colli_id
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      name="heavy_colli_id"
                                      id="add-offer-heavey-colli"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={
                                        validation.values.heavy_colli_id || ""
                                      }
                                    >
                                      <option value="">Choose...</option>
                                      {heaveyColli &&
                                        heaveyColli.map((heaveyColli, hc) => (
                                          <option
                                            key={"hc" + hc}
                                            value={heaveyColli.id}
                                          >
                                            {heaveyColli.heavy_collis}
                                          </option>
                                        ))}
                                    </select>
                                    {validation.touched.heavy_colli_id &&
                                    validation.errors.heavy_colli_id ? (
                                      <FormFeedback type="invalid">
                                        {validation.errors.heavy_colli_id}
                                      </FormFeedback>
                                    ) : null}
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="4">
                                  <div className="mb-3">
                                    <Label htmlFor="basicpill-npb-input12">
                                      Number of Units per Box
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      readOnly={true}
                                      name="units_per_box"
                                      type="text"
                                      className={
                                        validation.touched.units_per_box &&
                                        validation.errors.units_per_box
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      id="basicpil-npb-input12"
                                      placeholder="Number"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={
                                        validation.values.units_per_box || ""
                                      }
                                    />
                                    {validation.touched.units_per_box &&
                                    validation.errors.units_per_box ? (
                                      <FormFeedback type="invalid">
                                        {validation.errors.units_per_box}
                                      </FormFeedback>
                                    ) : null}
                                  </div>
                                </Col>
                                <Col lg="4">
                                  <div className="mb-3">
                                    <Label htmlFor="basicpill-bom-input12">
                                      BOM per article
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      readOnly={true}
                                      name="bom_per_article"
                                      type="text"
                                      className={
                                        validation.touched.bom_per_article &&
                                        validation.errors.bom_per_article
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      id="basicpill-bom-input12"
                                      placeholder="Number"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={
                                        validation.values.bom_per_article || ""
                                      }
                                    />
                                    {validation.touched.bom_per_article &&
                                    validation.errors.bom_per_article ? (
                                      <FormFeedback type="invalid">
                                        {validation.errors.bom_per_article}
                                      </FormFeedback>
                                    ) : null}
                                  </div>
                                </Col>
                                <Col lg="4">
                                  <div className="mb-3">
                                    <Label htmlFor="basicpill-mcb-input12">
                                      Master Cardboard Box
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      readOnly={true}
                                      name="master_cardboard_box"
                                      type="text"
                                      className={
                                        validation.touched
                                          .master_cardboard_box &&
                                        validation.errors.master_cardboard_box
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      id="basicpill-mcb-input12"
                                      placeholder="Number"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={
                                        validation.values
                                          .master_cardboard_box || ""
                                      }
                                    />
                                    {validation.touched.master_cardboard_box &&
                                    validation.errors.master_cardboard_box ? (
                                      <FormFeedback type="invalid">
                                        {validation.errors.master_cardboard_box}
                                      </FormFeedback>
                                    ) : null}
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="12">
                                  <div className="mb-3">
                                    <Label htmlFor="basicpill-pc-input1">
                                      Packing comments
                                    </Label>
                                    <textarea
                                      name="packing_comments"
                                      id="basicpill-pc-input1"
                                      className="form-control"
                                      rows="3"
                                      placeholder="Free Text"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={
                                        validation.values.packing_comments || ""
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>
                              {/* </Form> */}
                            </div>
                          </TabPane>
                          <TabPane tabId={3}>
                            <div>
                              <Row>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label htmlFor="add-offer-user-type">
                                      QA Users
                                    </Label>
                                    <select
                                      className="form-control"
                                      name="qa_user_id"
                                      id="add-offer-user-type"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.qa_user_id || ""}
                                    >
                                      <option value="">Choose...</option>
                                      {userListAccordingRole.length > 0 &&
                                        userListAccordingRole.map((u, ut) => (
                                          <option
                                            key={"ut" + ut}
                                            value={u.user_id}
                                          >
                                            {u.user_name}
                                          </option>
                                        ))}
                                    </select>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="12">
                                  <div className="mb-3">
                                    <Label htmlFor="basicpill-sr-input1">
                                      Sample Request
                                    </Label>
                                    <textarea
                                      name="sample_request"
                                      id="basicpill-sr-input1"
                                      className="form-control"
                                      rows="3"
                                      placeholder="Free Text"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={
                                        validation.values.sample_request || ""
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="12">
                                  <div className="mb-3">
                                    <Label htmlFor="basicpill-sm-input1">
                                      Sample comments
                                    </Label>
                                    <textarea
                                      name="sample_comments"
                                      id="basicpill-sm-input1"
                                      className="form-control"
                                      rows="3"
                                      placeholder="Free Text"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={
                                        validation.values.sample_comments || ""
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="12">
                                  <div className="mb-3">
                                    <Label htmlFor="basicpill-ss-input1">
                                      Sample status
                                    </Label>
                                    <textarea
                                      name="sample_status"
                                      id="basicpill-ss-input1"
                                      className="form-control"
                                      rows="3"
                                      placeholder="Free Text"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={
                                        validation.values.sample_status || ""
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="12">
                                  <div className="mb-3">
                                    <Label htmlFor="basicpill-qa-input1">
                                      QA Sample Checkin comments
                                    </Label>
                                    <textarea
                                      name="qa_sample_checking_comments"
                                      id="basicpill-qa-input1"
                                      className="form-control"
                                      rows="3"
                                      placeholder="Free Text"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={
                                        validation.values
                                          .qa_sample_checking_comments || ""
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="12">
                                  <div className="mb-3">
                                    <Label htmlFor="basicpill-sc-input1">
                                      Sales sample checkin comments
                                    </Label>
                                    <textarea
                                      name="sales_sample_checking_comments"
                                      id="basicpill-sc-input1"
                                      className="form-control"
                                      rows="3"
                                      placeholder="Free Text"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={
                                        validation.values
                                          .sales_sample_checking_comments || ""
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="12">
                                  <div className="mb-3">
                                    <Label htmlFor="basicpill-sf-input1">
                                      Sample freight cost
                                    </Label>
                                    <textarea
                                      name="sample_freight_cost"
                                      id="basicpill-sf-input1"
                                      className="form-control"
                                      rows="3"
                                      placeholder="Free Text"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={
                                        validation.values.sample_freight_cost ||
                                        ""
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="12">
                                  <div className="mb-3">
                                    <Label htmlFor="basicpill-smm-input1">
                                      Sample main material
                                    </Label>
                                    <textarea
                                      name="sample_main_material"
                                      id="basicpill-smm-input1"
                                      className="form-control"
                                      rows="3"
                                      placeholder="Free Text"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={
                                        validation.values
                                          .sample_main_material || ""
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="12">
                                  <div className="mb-3">
                                    <Label htmlFor="basicpill-sh-input1">
                                      Sample hardware
                                    </Label>
                                    <textarea
                                      name="sample_hardware"
                                      id="basicpill-sh-input1"
                                      className="form-control"
                                      rows="3"
                                      placeholder="Free Text"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={
                                        validation.values.sample_hardware || ""
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="12">
                                  <div className="mb-3">
                                    <Label htmlFor="basicpill-sst-input1">
                                      Sample surface treatment
                                    </Label>
                                    <textarea
                                      name="sample_surface_treatment"
                                      id="basicpill-sst-input1"
                                      className="form-control"
                                      rows="3"
                                      placeholder="Free Text"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={
                                        validation.values
                                          .sample_surface_treatment || ""
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </TabPane>
                        </TabContent>
                      </div>
                      <div className="actions clearfix">
                        <ul>
                          <li
                            className={
                              activeTab === 1 ? "previous disabled" : "previous"
                            }
                          >
                            <Link
                              to="#"
                              onClick={() => {
                                toggleTab(activeTab - 1)
                              }}
                            >
                              Previous
                            </Link>
                          </li>
                          <li className={activeTab !== 3 ? "next" : "next"}>
                            {activeTab !== 3 ? (
                              <Link
                                to="#"
                                onClick={() => {
                                  toggleTab(activeTab + 1)
                                }}
                              >
                                Next
                              </Link>
                            ) : (
                              <button
                                type="submit"
                                className="btn btn-primary w-md"
                                disabled={offer && offer.loading ? true : false}
                              >
                                {offer && offer.loading
                                  ? "Updating Offer"
                                  : "Update Offer"}
                              </button>
                            )}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default QaEditOffer
